<form [formGroup]="form()">
  <div class="container">
    @let controls = form().controls;
    <onyx-form-group [controls]="controls.date" width="200px">
      <onyx-datepicker
        [formControl]="controls.date"
        label="labels.paymentDate"
        [showErrors]="false"
      ></onyx-datepicker>

      <onyx-suggestions
        [suggestions]="DATE_SUGGESTIONS"
        [control]="controls.date"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-toggle
      [label]="`${I18N}.partiallyPaid`"
      [(checked)]="isPartiallyPaid"
      [disabled]="
        [OrderStatus.PARTIALLY_PAID, OrderStatus.PAID].includes(
          this.order().status.value
        )
      "
    ></onyx-toggle>
  </div>

  @if (isPartiallyPaid()) {
    <div class="container">
      @let netControls = controls.net.controls;
      @let vatControls = controls.vat.controls;
      <onyx-form-group
        class="partial-payment"
        [controls]="netControls.value"
        label="labels.netAmount"
        width="200px"
      >
        <onyx-text-field
          [formControl]="netControls.value"
          [decimalPlaces]="2"
          [placeholder]="netControls.value.disabled ? 'labels.paid' : ''"
          [unit]="netCurrency() ?? '' | uppercase"
          [showErrors]="false"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="netControls.value"
          [suggestions]="remainingNetSuggestions()"
        ></onyx-suggestions>
      </onyx-form-group>

      @if (showVat()) {
        <onyx-form-group
          class="partial-payment"
          [controls]="vatControls.value"
          label="labels.vatAmount"
          width="200px"
        >
          <onyx-text-field
            [formControl]="vatControls.value"
            [decimalPlaces]="2"
            [placeholder]="vatControls.value.disabled ? 'labels.paid' : ''"
            [unit]="vatCurrency() ?? '' | uppercase"
            [showErrors]="false"
          ></onyx-text-field>

          <onyx-suggestions
            [control]="vatControls.value"
            [suggestions]="remainingVatSuggestions()"
          ></onyx-suggestions>
        </onyx-form-group>
      }
    </div>
  }
</form>
